module.exports = __webpack_public_path__ + "static/media/mapmark.bec719e6.svg";